(function () {
  if (!window.matchMedia) return;

  var SELECTOR = 'announcement-bar-component.announcement-bar__slider--inline[autoplay]';
  var mq = window.matchMedia('(min-width: 750px)');

  function bars() {
    return Array.prototype.slice.call(document.querySelectorAll(SELECTOR));
  }

  function apply(bar) {
    if (typeof bar.play !== 'function') return;
    if (mq.matches) {
      if (typeof bar.pause === 'function') bar.pause();
      var scope = bar.closest('.shopify-section') || bar;
      scope.querySelectorAll('slideshow-slide.announcement-bar__slide').forEach(function (slide) {
        slide.setAttribute('aria-hidden', 'false');
      });
    } else {
      try {
        bar.current = bar.current;
      } catch (e) {}
      if (typeof bar.suspend === 'function') bar.suspend();
      bar.play();
    }
  }

  function applyAll() {
    bars().forEach(apply);
  }

  function whenReady(callback) {
    if (window.customElements && customElements.whenDefined) {
      customElements.whenDefined('announcement-bar-component').then(callback);
    } else {
      callback();
    }
  }

  whenReady(applyAll);

  if (mq.addEventListener) {
    mq.addEventListener('change', applyAll);
  } else if (mq.addListener) {
    mq.addListener(applyAll);
  }

  document.addEventListener('visibilitychange', function () {
    if (document.hidden || mq.matches) return;
    bars().forEach(function (bar) {
      if (typeof bar.play !== 'function') return;
      if (typeof bar.suspend === 'function') bar.suspend();
      bar.play();
    });
  });

  document.addEventListener('shopify:section:load', function () {
    whenReady(applyAll);
  });
})();
